module.exports = __webpack_public_path__ + "static/media/logo-donts-2.9fad9679.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-donts-2.png
// module id = 1305
// module chunks = 0